/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'
import UiButton, { UiButtonSize, UiButtonStyle } from './UiButton'

type UiConfirmDialogProps = {
    title: React.ReactNode
    message: React.ReactNode
    confirmText: React.ReactNode
    cancelText: React.ReactNode
    onConfirm: () => void
    onCancel: () => void
    danger?: boolean
    className?: string
}

const UiConfirmDialog: React.FC<UiConfirmDialogProps> = ({
    title,
    message,
    confirmText,
    cancelText,
    onConfirm,
    onCancel,
    danger,
    className,
}) => {
    return (
        <div
            className={clsx(
                'UiConfirmDialog w-full max-w-md mx-auto rounded-xl border border-gray-200 bg-white shadow-md dark:border-gray-700 dark:bg-gray-900',
                'px-6 py-5',
                className
            )}
            role={'dialog'}
            aria-modal={'true'}
        >
            <div className={clsx('space-y-2')}>
                <div className={clsx('text-base font-semibold text-gray-900 dark:text-gray-100')}>
                    {title}
                </div>
                <div className={clsx('text-sm text-gray-700 dark:text-gray-300')}>{message}</div>
            </div>
            <div className={clsx('mt-5 flex items-center justify-end gap-2')}>
                <UiButton
                    size={UiButtonSize.Medium}
                    style={UiButtonStyle.Secondary}
                    onClick={onCancel}
                >
                    {cancelText}
                </UiButton>
                <UiButton
                    size={UiButtonSize.Medium}
                    style={danger ? UiButtonStyle.Red : UiButtonStyle.Primary}
                    onClick={onConfirm}
                >
                    {confirmText}
                </UiButton>
            </div>
        </div>
    )
}

export default UiConfirmDialog
